import { Injectable } from '@angular/core';
import io from 'socket.io-client';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { LocalService } from '@app/@core/services/local.service';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  private socket;
  chatBotUrl = environment.ChatBotNew;
  constructor(private http: HttpClient, private sessionStorage: LocalService) {
     // This is intentional
  }

  public connect(url: string) {
    const tokenvalues = this.sessionStorage.getItem('fbToken') ? this.sessionStorage.getItem('fbToken') : '';
    const username = this.sessionStorage.getItem('username') ? this.sessionStorage.getItem('username') : '';
    const email = this.sessionStorage.getItem('email') ? this.sessionStorage.getItem('email') : '';
    const id = this.sessionStorage.getItem('id') ? this.sessionStorage.getItem('id') : '';
    this.socket = io(url, {
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: Infinity,
      forceNew: true,
      secure: true,
      query: {
        token: tokenvalues ? tokenvalues : '',
        username: username ? username : 'Tulasireddy',
        email: email ? email : 'tulasi@cardinality.ai',
        id: id ? id : '1234'
      }
    });
    this.socket.on('connect', () => {
      this.socket.emit('session_request', { session_id: this.socket.id });
    });
    this.socket.on('session_confirm', _remote_id => {
      //not to be empty
    });
    this.socket.on('connect_error', error => {
      console.log(error);
    });

    this.socket.on('error', error => {
      console.log(error);
    });

    this.socket.on('disconnect', reason => {
      console.log(reason);
    });
  }

  public sendMessage(message) {
    const tokenvalues = this.sessionStorage.getItem('fbToken') ? this.sessionStorage.getItem('fbToken') : '';
    const username = this.sessionStorage.getItem('username') ? this.sessionStorage.getItem('username') : '';
    const email = this.sessionStorage.getItem('email') ? this.sessionStorage.getItem('email') : '';
    const id = this.sessionStorage.getItem('id') ? this.sessionStorage.getItem('id') : '';
    this.socket.emit('user_uttered', {
      message: message,
      customData: {
        token: tokenvalues ? tokenvalues : '',
        username: username ? username : '',
        email: email ? email : '',
        id: id ? id : ''
      }
    });
  }

  public getMessages = () =>
    new Observable(observer => {
      this.socket.on('bot_uttered', message => {
        message.text = message.text.replaceAll('\n', '<br />');
        console.log({ message });
        observer.next(message);
      });
    });
  public disconnect() {
    this.socket.on('disconnect', reason => {
      console.log(reason);
    });
  }
  public searchMenus(modal) {
    const inputRequest = {
      query: modal
    };
    return this.http.post(this.chatBotUrl + 'search', inputRequest);
  }
  public sendFeedback(modal) {
    const inputRequest = {
      user: this.sessionStorage.getItem('username') ? this.sessionStorage.getItem('username') : '',
      question: modal.question,
      isLiked: modal.islike ? true : false
    };
    return this.http.post(this.chatBotUrl + 'feedback', inputRequest);
  }
}
